import Vue from 'vue'

const store = {
  install (V) {
    Vue.prototype.store = new Vue({
      data () {
        return {}
      },
      methods: {
        // save an item to localStorage
        setItem (key, value) {
          return localStorage.setItem(key, JSON.stringify(value))
        },

        // retrieve an item from localStorage
        getItem (key) {
          if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
            return {}
          }
          return JSON.parse(localStorage.getItem(key))
        },

        getItemByCategory (key, name) {
          if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
            return false
          } else {
            let res = JSON.parse(localStorage.getItem(key))
            return res[name] !== undefined ? res[name] : []
          }
        },

        getItemOrFalse (key) {
          if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
            return false
          }
          return JSON.parse(localStorage.getItem(key))
        },

        // Creates element only if not existing
        createIfNotExisting (key, value) {
          if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
            return localStorage.setItem(key, JSON.stringify(value))
          } else {
            return JSON.parse(localStorage.getItem(key))
          }
        },

        // retrieve an item from localStorage
        getItemOrDefault (key, defaultValue) {
          if (localStorage.getItem(key) === undefined || localStorage.getItem(key) === null) {
            return defaultValue
          }

          return JSON.parse(localStorage.getItem(key))
        },

        // remove one item from localStorage
        removeItem (key) { // TODO: Should be named emptyItem
          return this.setItem(key, {})
        },

        // remove one item from localStorage
        clearItem (key) {
          return localStorage.removeItem(key) // this.setItem(key, {})
        },

        // remove all items from localStorage
        clear () {
          localStorage.clear()
        }
      }
    })
  }
}

if (window !== undefined && window.Vue) {
  window.Vue.use(store)
}

export default store



// WEBPACK FOOTER //
// ./src/plugins/vue-store/index.js